import React from 'react';
import colors from '../../../styles/colors';

const Passive: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center"
    style={{backgroundColor: colors.veryDarkBrown, color: colors.lightCream}}>
      <h1 className="text-4xl font-bold">Passive Windows</h1>
      <p>Details about our passive windows.</p>
    </div>
  );
};

export default Passive;
